module.exports = __webpack_public_path__ + "static/media/externalBarn_12.0484a858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_12.png
// module id = 1300
// module chunks = 3